import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../../query.client';
import { readAllSineHostGroups } from '../core/core.service';
import teamService from './team.service';

export function useMyTeams() {
  return useQuery({
    queryKey: [QueryKeys.MY_TEAMS],
    queryFn: teamService.getAllMyTeams,
  });
}
export function useHostGroups(limit: number, offset: number, searchTerm?: string, siteId?: string) {
  return useQuery({
    queryKey: [QueryKeys.HOST_GROUPS, limit, offset, searchTerm, siteId],
    queryFn: () => readAllSineHostGroups(limit, offset, searchTerm, siteId),
    keepPreviousData: true,
  });
}
